var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSidebarApplications(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 11.309,
    height: 13.571,
    viewBox: "0 0 11.309 13.571",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "assept-document_1_",
    "data-name": "assept-document (1)",
    d: "M8.785,3.958V.26a3.945,3.945,0,0,1,1.394.9l1.97,1.971a3.932,3.932,0,0,1,.9,1.393h-3.7a.565.565,0,0,1-.565-.565Zm4.523,1.971v4.815a2.831,2.831,0,0,1-2.827,2.827H4.827A2.831,2.831,0,0,1,2,10.744V2.827A2.831,2.831,0,0,1,4.827,0H7.38c.092,0,.183.007.274.014V3.958a1.7,1.7,0,0,0,1.7,1.7H13.3C13.3,5.746,13.309,5.837,13.309,5.929ZM10.325,8.092a.565.565,0,0,0-.8-.02l-2.036,1.94a.565.565,0,0,1-.823-.023l-.9-.8a.566.566,0,0,0-.753.845l.873.777a1.7,1.7,0,0,0,2.39.01l2.027-1.93a.565.565,0,0,0,.02-.8Z",
    transform: "translate(-2)",
    fill: "#387F75"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSidebarApplications);
export default __webpack_public_path__ + "static/media/sidebar-applications.7cd2c8cea7fae3756ca738f03724058a.svg";
export { ForwardRef as ReactComponent };